<template>
    <Modal modalId="generator-features-modal" size="modal-md">
        <ModalHeader :title="$t('xWhatAreTheFeatures')" icon="far fa-circle-info colorOrange mr-1"
            :style="{ padding: '4px 12px' }">
            <div class="cols-auto">
                <button type="button" class="btn btn-icon-button btn-icon-button--gray"
                    @click="closeGeneratorFeaturesModal()" data-test-hook="CloseModalBtn">
                    <i class="fas fa-times" />
                </button>
            </div>
        </ModalHeader>
        <ModalBody>
            <div class="features">
                <div class="basic">
                    <p class="mb-1" data-test-hook="generator-features-modal-generator-basic-features-text">
                        <strong>{{ $t('xFeaturesIncludedInPlan') }}{{ $t('xBasic') }}</strong>
                    </p>
                    <div class="feature">
                        <i class="far fa-fw fa-clipboard-list"></i>
                        <div>
                            <p class="basic-features"
                                data-test-hook="generator-features-modal-generator-basic-features-text">
                                {{ $t('xFeaturesIncludedWiFiAnnuallySubscriptionFeature1') }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="premium">
                    <p class="mb-1" data-test-hook="generator-features-modal-generator-premium-features-text">
                        <strong>{{ $t('xAdditionalFeatuesInPremium') }}</strong>
                    </p>
                    <div class="feature">
                        <i class="far fa-fw fa-bell"></i>
                        <div class="mb-2">
                            <p class="premium-feature-text"
                                data-test-hook="generator-features-modal-generator-premium-real-time-alerts-header-text">
                                {{ $t('xRealTimeAlerts') }}
                            </p>
                            <p class="premium-feature-supporting-text"
                                data-test-hook="generator-features-modal-generator-premium-real-time-alerts-supporting-text">
                                {{ $t('xRealTimeAlertsDesc') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="far fa-fw fa-calendar"></i>
                        <div class="mb-2">
                            <p class="premium-feature-text"
                                data-test-hook="generator-features-modal-generator-premium-exercise-settings-header-text">
                                {{ $t('xExerciseSettings') }}
                            </p>
                            <p class="premium-feature-supporting-text"
                                data-test-hook="generator-features-modal-generator-premium-exercise-settings-supporting-text">
                                {{ $t('xExerciseSettingsDesc') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="far fa-fw fa-arrows-spin"></i>
                        <div class="mb-2">
                            <p class="premium-feature-text"
                                data-test-hook="generator-features-modal-generator-premium-exercise-on-demand-header-text">
                                {{ $t('xExerciseOnDemand') }}
                            </p>
                            <p class="premium-feature-supporting-text"
                                data-test-hook="generator-features-modal-generator-premium-exercise-on-demand-supporting-text">
                                {{ $t('xExerciseOnDemandDesc') }}
                            </p>
                        </div>
                    </div>
                    <div class="feature">
                        <i class="far fa-fw fa-warning"></i>
                        <div>
                            <p class="premium-feature-text"
                                data-test-hook="generator-features-modal-generator-premium-dismiss-warnings-header-text">
                                {{ $t('xDismissWarnings') }}
                            </p>
                            <p class="premium-feature-supporting-text"
                                data-test-hook="generator-features-modal-generator-premium-dismiss-warnings-supporting-text">
                                {{ $t('xDismissWarningsDesc') }}
                            </p>
                        </div>
                    </div>
                </div>
                <p class="premium-feature-supporting-text"
                    data-test-hook="generator-features-modal-standard-rates-apply-text">
                    {{ '*' + $t('xStandardDataRatesPlansAutoRenew') }}
                </p>
            </div>
        </ModalBody>
    </Modal>
</template>

<script>
export default {
    methods: {
        closeGeneratorFeaturesModal() {
            this.closeModal('generator-features-modal')
        }
    }
}
</script>

<style scoped lang="scss">
.features {
    gap: 0.75em;
    display: flex;
    flex-direction: column;
}
.feature {
    display: flex;
    align-items: center;
    gap: 0.5em;

    i {
        font-size: 1.125em;
        color: var(--carbon-600);
    }

    div {
        flex: 1;
    }
}
.basic-features {
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 0;
}
.premium-feature-text {
    font-weight: 600;
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 2px;
}
.premium-feature-supporting-text {
    font-size: 0.875em;
    line-height: 1.35;
    margin-bottom: 0;
    color: var(--carbon-600);
}
</style>